var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5517 0.69873H9.90655C9.55109 0.69873 9.2627 0.917209 9.2627 1.1865V4.70335C9.2627 4.95009 9.5267 5.15009 9.85239 5.15009H16.0851C16.4406 5.15009 16.7289 5.36857 16.7289 5.63786V15.7254C16.7289 15.9495 16.9689 16.1313 17.2648 16.1313H23.5513C23.9068 16.1313 24.1952 15.9129 24.1952 15.6436V1.1865C24.1952 0.917209 23.9072 0.69873 23.5517 0.69873Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0342 5.86847H1.3891C1.03363 5.86847 0.745239 6.08695 0.745239 6.35624V20.8133C0.745239 21.0826 1.03363 21.3011 1.3891 21.3011H15.0342C15.3897 21.3011 15.6781 21.0826 15.6781 20.8133V6.35624C15.6781 6.08695 15.3897 5.86847 15.0342 5.86847ZM11.8121 14.1693L8.52068 17.4935C8.36609 17.6494 8.05725 17.6494 7.90265 17.4935L4.61126 14.1693C4.50831 14.0652 4.50831 13.922 4.61126 13.8179L7.90265 10.4937C8.05725 10.3378 8.36609 10.3378 8.52068 10.4937L11.8121 13.8179C11.915 13.922 11.915 14.0652 11.8121 14.1693Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino);
export default __webpack_public_path__ + "static/media/casino.b6797b3bca6510681c203145bd7badf8.svg";
export { ForwardRef as ReactComponent };